<template>
  <div class>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-size:20px;color:#000;">基本信息</span>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" style="width: 400px;">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-size:20px;color:#000;">权限范围</span>
      </div>
      <el-form :model="secondForm" label-width="120px">
        <el-form-item label="公司权限" style="width: 500px;">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText2">
          </el-input>
          <el-tree
            class="filter-tree"
            :data="datatree2"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            :filter-node-method="filterNode2"
            ref="tree2">
          </el-tree>
        </el-form-item>
        <!-- <el-form-item label="设备权限" style="width: 500px;">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText">
          </el-input>
          <el-tree
            class="filter-tree"
            :data="datatree"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            :filter-node-method="getCheckedNodes"
            ref="tree">
          </el-tree>
        </el-form-item> -->
      </el-form>
      <div style="margin-left:200px">
        <el-button @click="cancel" class="resetbtn">取消</el-button>
        <el-button type="success" @click="onSubmit(true)">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapAction } from "vuex";
export default {
  name: "xinzengjuese",
  components: {},
  data() {
    return {
      form: {
        name: ""
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ]
      },
      secondForm:{},
      // datatree:[],
      datatree2:[],
      // filterText: "",
      filterText2: "",
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isShow: true,
      ids: [],
      station: [],
      org: [],
      org1: [],
      organ:[],
      org2:[]
    };
  },
  computed: {
  },
  methods: {

    async onSubmit(flag) {

      try {
          //必填校验
          await Promise.all([
              this.$refs.form.validate()
          ]);
      } catch (error) {
          return;
      }
      if (!flag) {
        this.$router.go(-1)
        return;
      }
      this.ids = []
      this.org = []

      this.station = []
      this.org1 = []

      this.organ = []
      this.org2 = []
      if(this.$refs.tree2.getCheckedNodes(false,true)){
        const nodes2 = this.$refs.tree2.getCheckedNodes(false,true);
        for (var i = 0; i < nodes2.length; i++) {
          const node = nodes2[i];
          if (!node.noData) {
            this.organ.push(node.id)
            this.org2.push(node.id)
          }
        }
      }
      // if(this.$refs.tree.getCheckedNodes(false,true)){
      //   const nodes = this.$refs.tree.getCheckedNodes(false,true);
      //   for (var i = 0; i < nodes.length; i++) {
      //     const node = nodes[i];
      //     if (!node.noData) {
      //       this.ids.push(node.id)
      //       this.org.push(node.id)
      //     }
      //   }
      // }


      // const items = this.$refs.tree1.getCheckedNodes(false,true);
      // console.log("item",items)
      // for (var i = 0; i < items.length; i++) {
      //   const item = items[i];
      //   if (item.attrs.type == "org") {
      //     this.org1.push(item.id);
      //   } else if (item.attrs.type == "station") {
      //     this.station.push(item.id);
      //   }
      // }

      for (var i = 0 ; i < this.org.length ; i ++ ){
        for(var j = 0 ; j < this.org2.length ; j ++ ){
          if (this.org[i] === this.org2[j]){
            this.org.splice(i,1); //利用splice函数删除元素，从第i个位置，截取长度为1的元素
          }
        }
      }
      for(var i = 0; i <this.org2.length; i++){
        this.org.push(this.org2[i]);
      }

      let data = {
        name: this.form.name,
        data: {
          "org": this.org,
          "org.user": this.ids,
          "org.station": this.station
        }
      }
      this.$store.dispatch("form/handle", {
        url: "/auth",
        data: data,
        method: "put",
        callback: resp => {
          console.log(resp)
          this.$router.go(-1)
        }
      });
      //   }
      // });
    },
    cancel(){
      this.$router.go(-1)
    },

    // filterNode(value, data) {
    //   if (!value) return true;
    //   return data.name.indexOf(value) !== -1;
    // },

    filterNode2(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getOrganTree(){
      let data = {
        bizType:"org"
      }
      this.$store.dispatch("form/handle",{
        url:'/auth/findMy',
        data:data,
        method:"get",
        callback:resp=>{
          this.datatree2 = resp
        }
      })
    },

    // getOrgTree() {
    //   let data = {
    //     bizType: "org.station"
    //   }
    //   this.$store.dispatch("form/handle",{
    //     url:"/auth/findMy",
    //     data: data,
    //     method:"get",
    //     callback:resp=>{
    //       this.datatree = resp
    //     }
    //   })
    // },


  },
  mounted() {
    // this.getOrgTree()
    // this.getStationTree()
    this.getOrganTree()
  },
  watch: {
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // },
    filterText2(val) {
      this.$refs.tree2.filter(val);
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/userManagement/addrole.vue